import React from 'react';
import { PRICE_PER_EMPLOYEE, COURSE_COUNT, eur } from './HeroCalculator';

const EMPLOYEES = 10;
const TRAINER_FEE = 600;
const HOURS_LOST = 4;
const HOURLY_COST = 50;

export const ExampleCalculation = () => {
  const smartvoltYear = EMPLOYEES * PRICE_PER_EMPLOYEE * 12;
  const classicOne = TRAINER_FEE + EMPLOYEES * HOURS_LOST * HOURLY_COST;
  const perEmployeeCourseYear = (PRICE_PER_EMPLOYEE * 12) / COURSE_COUNT;

  return (
    <div className="rounded-2xl border border-gray-800 bg-gray-900/60 p-6 sm:p-8" data-testid="example-calculation">
      <p className="text-yellow-400 text-[11px] font-black uppercase tracking-widest mb-2">Beispielrechnung</p>
      <h3 className="text-lg sm:text-xl font-bold text-white mb-6">Elektrobetrieb mit {EMPLOYEES} Mitarbeitern</h3>

      <div className="grid md:grid-cols-2 gap-4">
        <div className="rounded-xl border border-yellow-500/40 bg-yellow-500/5 p-5" data-testid="example-smartvolt">
          <p className="text-sm font-bold text-yellow-400 mb-3">SmartVolt Academy</p>
          <p className="text-gray-300 text-sm">{EMPLOYEES} × {eur(PRICE_PER_EMPLOYEE)} € × 12 Monate</p>
          <p className="text-3xl font-black text-white mt-1">{eur(smartvoltYear)} € <span className="text-sm text-gray-400 font-medium">/ Jahr</span></p>
          <p className="text-xs text-gray-400 mt-2">alle {COURSE_COUNT} Kurse · Zertifikate · Nachweis-Doku · kein Arbeitsausfall durch Termine</p>
        </div>
        <div className="rounded-xl border border-gray-700 bg-black/30 p-5" data-testid="example-classic">
          <p className="text-sm font-bold text-gray-300 mb-3">Klassische Präsenz-Unterweisung</p>
          <p className="text-gray-400 text-sm">Referent ca. {eur(TRAINER_FEE)} € + Ausfall {EMPLOYEES} × {HOURS_LOST} h × {HOURLY_COST} €</p>
          <p className="text-3xl font-black text-gray-200 mt-1">≈ {eur(classicOne)} € <span className="text-sm text-gray-500 font-medium">für 1 Thema</span></p>
          <p className="text-xs text-gray-500 mt-2">jedes weitere Pflichtthema kostet erneut</p>
        </div>
      </div>

      <p className="mt-5 text-center text-sm sm:text-base text-gray-200" data-testid="example-per-course">
        Pro Mitarbeiter und Kurs zahlen Sie bei SmartVolt nur <strong className="text-yellow-400">ca. {eur(perEmployeeCourseYear)} € im Jahr</strong>.
      </p>
      <p className="mt-2 text-center text-[11px] text-gray-500">
        Beispielwerte für Referentenhonorar und Stundensatz – die tatsächlichen Kosten variieren je nach Region und Betrieb. Preise zzgl. MwSt.
      </p>
    </div>
  );
};

export default ExampleCalculation;
